import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { faCheck, faCloudUploadAlt, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { DOCUMENT_FILTERS, DocumentState } from '../../../store/state/document.state';
import { DocBoxState } from '../../../store/state/docBox.state';
import { FormGroup } from '@angular/forms';
import { UiResponsiveService } from '@evorait/pace-core';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'pace-forms-docbox-filter-header',
    templateUrl: './docbox-filter-header.component.html',
    styleUrls: ['./docbox-filter-header.component.scss'],
})
export class DocBoxFilterHeaderComponent implements OnInit, OnDestroy {
    @Input()
    public docBox: DocBoxState;

    @Input()
    public docBoxGroup: FormGroup;

    @Input()
    public enableIndividualDownload: boolean;

    @Output()
    public clearFilterAction = new EventEmitter<DOCUMENT_FILTERS>();

    @Output()
    public showUploadPopup = new EventEmitter<void>();

    @Output()
    public sortByFieldAction = new EventEmitter<keyof DocumentState>();

    @Output()
    public selectAllDocuments = new EventEmitter<void>();

    protected readonly faCheck = faCheck;
    protected readonly faCloudUploadAlt = faCloudUploadAlt;
    protected readonly faSortUp = faSortUp;
    protected readonly faSortDown = faSortDown;
    protected readonly filters = DOCUMENT_FILTERS;

    protected isFilterCriteriaExpanded = false;
    protected isMobile = false;

    private unsubscribeAll = new Subject<void>();
    public constructor(private readonly uiResponsiveService: UiResponsiveService) {}

    public ngOnInit(): void {
        this.uiResponsiveService.isMobile$
            .pipe(takeUntil(this.unsubscribeAll), distinctUntilChanged())
            .subscribe((isMobile) => {
                this.isMobile = isMobile;
                this.isFilterCriteriaExpanded = !isMobile;
            });
    }

    public ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    public toggleFilterCriteriaExpanded(): void {
        this.isFilterCriteriaExpanded = !this.isMobile || !this.isFilterCriteriaExpanded;
    }

    public clearFilter(filter: DOCUMENT_FILTERS): void {
        this.clearFilterAction.emit(filter);
    }

    public sortByField(field: keyof DocumentState): void {
        this.sortByFieldAction.emit(field);
    }
}
